import { Spin, Tree, TreeProps } from 'antd'

import { DataError } from '@eastcoal/common/components/DataError'
import { pick } from '@eastcoal/common/utils/object'

import { useAreaTreeStore } from '../Store/hooks'

const fieldNames: TreeProps['fieldNames'] = {
  key: 'id',
  title: 'name',
  children: 'children'
}

export const AreaTreeCore = () => {
  const {
    data,
    error,
    loading,
    selectedKeys,
    expandedKeys,
    setExpandedKeys,
    setSelectedKeys,
    reload
  } = useAreaTreeStore(state =>
    pick(state, [
      'data',
      'error',
      'loading',
      'selectedKeys',
      'expandedKeys',
      'setSelectedKeys',
      'setExpandedKeys',
      'reload'
    ])
  )

  return (
    <Spin spinning={loading}>
      <DataError error={error} reload={reload} />
      <Tree
        blockNode
        selectable
        draggable={false}
        expandedKeys={expandedKeys}
        fieldNames={fieldNames}
        height={520}
        selectedKeys={selectedKeys}
        treeData={data as any}
        onExpand={setExpandedKeys as any}
        onSelect={setSelectedKeys as any}
      />
    </Spin>
  )
}
